import { Component, OnInit } from '@angular/core';
import { DynamicForm } from '../../models/dynamic.form';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItems } from '../../../../shared/Models/SelectItems';
import { FormMAsterService } from '../../services/formMaster.service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';

@Component({
  selector: 'app-create-form',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class CreateFormComponent implements OnInit {
  dForm: DynamicForm = {} as DynamicForm;
  activityTypesOptions: SelectItems[];
  sloganError: boolean;
  titleError: boolean;

  constructor(
    private service: FormMAsterService,
    private router: Router,
    private diag: NbDialogRef<CreateFormComponent>,
    private toast: NbToastrService
  ) {}

  ngOnInit() {
    this.loadRequiredCreateDate();
  }
  loadRequiredCreateDate() {
    this.service.getCreateNew().subscribe((res) => {
      this.activityTypesOptions = res[0].values;
    });
  }
  dropdownChange($event) {}
  save() {
    this.sloganError = false;
    this.titleError = false;
    this.service.post(this.dForm).subscribe(
      (res) => {
        this.toast.success(`add form ${this.dForm.title} successfully`, 'success', { duration: 4000 });

        this.diag.close('true');
      },
      (err) => {
        if (err.error.errors != null && err.error.errors.length > 0) {
          err.error.errors.forEach((element) => {
            if (element.code === 300) {
              this.sloganError = true;
            }
            if (element.code === 301) {
              this.titleError = true;
            }
          });
        }
      }
    );
  }
  back() {
    this.diag.close();
  }
}
